import { OnInit, OnDestroy, Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { AppDefinitions, DefinitionKey } from "../services/app-definitions.service";
import { OrgNameAndIdentifier } from "../types";

@Injectable()
export abstract class PageComponentBase implements OnInit, OnDestroy {
    public _initialized = false;

    protected _destroyed$ = new Subject<void>();

    constructor(public _definitions: AppDefinitions) {}

    protected abstract _getRequiredDefinitions(): DefinitionKey[];
    protected abstract _activate(): void;

    ngOnInit(): void {
        this._prepare().subscribe({
            complete: () => {
                this._initialized = true;
                this._activate();
            }
        });
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    protected _prepare(): Observable<void | any[]> {
        return this._definitions.load(...this._getRequiredDefinitions());
    }
}
